import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "font-bold text-xl"
};
const _hoisted_2 = {
  class: "text-xl font-bold"
};
import { generateColorMap } from "@/modules/vue/utils";
import { app } from "@/di";
import Effects from "@/modules/club-grounds/components/slot-types/Effects.vue";
import GroundSlotConfigProvider from "@/modules/club-grounds/services/GroundSlotConfigProvider";
import SimpleActionSheet from "@/modules/vue/components/SimpleActionSheet.vue";
import SimpleActionSheetBuyItem from "@/modules/vue/components/SimpleActionSheetBuyItem.vue";
import SlideSelect from "@/modules/vue/components/SlideSelect.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'DevelopmentActionSheet',
  props: {
    groundSlot: null
  },
  emits: ['apply'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const actionSheet = ref();
    const show = () => nextTick(() => actionSheet.value.show());
    const hide = () => nextTick(() => actionSheet.value.hide());
    // const currentType = computed(() => types.value[current.value]);
    const types = computed(() => app.get(GroundSlotConfigProvider).get(props.groundSlot));
    const currentType = ref(types.value[0]);
    const colorMap = generateColorMap({
      bg: 800,
      text: 50
    });
    const onBuy = async () => {
      await hide();
      emit('apply', currentType.value.id);
    };
    expose({
      show,
      hide
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(SimpleActionSheet, {
        ref_key: "actionSheet",
        ref: actionSheet,
        "no-scrollbar": ""
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('develop_ground_slot')), 1)]),
        actions: _withCtx(() => [_createVNode(SimpleActionSheetBuyItem, {
          price: currentType.value.price,
          onClick: onBuy
        }, null, 8, ["price"])]),
        default: _withCtx(() => [_createVNode(SlideSelect, {
          modelValue: currentType.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => currentType.value = $event),
          items: _unref(types),
          full: ""
        }, {
          item: _withCtx(({
            item
          }) => [(_openBlock(), _createElementBlock("div", {
            key: item.id,
            class: _normalizeClass(["flex flex-col items-center justify-center", _unref(colorMap)[item.color]])
          }, [_createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t(item.id)), 1), _createElementVNode("div", null, _toDisplayString(_ctx.$duration(item.duration, 'months').humanize()), 1), _createVNode(Effects, {
            effects: item.effects,
            class: "my-4 text-center"
          }, null, 8, ["effects"]), _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$money(item.price)), 1)], 2))]),
          _: 1
        }, 8, ["modelValue", "items"])]),
        _: 1
      }, 512);
    };
  }
});